import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const EmailIdCreation = React.lazy(() => import("@/pages/emailIdCreation/Index"));

const EmailIdCreationRouter = [
    {
        path: "emailIdCreationEmployee",
        element: (
            <SuspenseWrapper>
                <EmailIdCreation />
            </SuspenseWrapper>
        ),
    },
];

export default EmailIdCreationRouter;
